import { patchCommercialBOMList, patchResearchBOMList, } from "@erp/shared/api/generated/wrappers/product";
import { postCommercialBOMList, postResearchBOMList, } from "@erp/shared/api/generated/wrappers/product";
import { deleteCommercialProduct, deleteResearchProduct, } from "@erp/shared/api/generated/wrappers/product";
import { patchCommercialProduct, patchResearchProduct, } from "@erp/shared/api/generated/wrappers/product";
import { postCommercialProduct, postResearchProduct, } from "@erp/shared/api/generated/wrappers/product";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { usePageInfo } from "@erp/shared/composables/usePageInfo";
import { useState } from "@erp/shared/composables/useState";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
export const useProductAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const { isCommercialPage } = usePageInfo();
    const [productId, setProductId] = useState(null);
    const readBOMQueryOptions = computed(() => {
        return { ...queries.stock.bom(isCommercialPage.value, productId.value ?? 0),
            enabled: computed(() => !!productId.value),
        };
    });
    const readBOMQuery = useQuery(readBOMQueryOptions);
    const createBOMMutation = useMutation({
        mutationFn: async (body) => {
            return isCommercialPage.value
                ? await postCommercialBOMList(body)
                : await postResearchBOMList(body);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "BOM 생성 실패");
        },
        onSuccess: () => {
            showAlert("BOM 생성 완료", "완료");
            invalidateQueries([
                queries.product._def,
                queries.stock._def,
            ]);
        },
    });
    const updateBOMMutation = useMutation({
        mutationFn: async (body) => {
            return isCommercialPage.value
                ? await patchCommercialBOMList(body)
                : await patchResearchBOMList(body);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "BOM 수정 실패");
        },
        onSuccess: () => {
            showAlert("BOM 수정 완료", "완료");
            invalidateQueries([
                queries.product._def,
                queries.stock._def,
            ]);
        },
    });
    const createProductMutation = useMutation({
        mutationFn: async (body) => isCommercialPage.value
            ? await postCommercialProduct(body)
            : await postResearchProduct(body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "제품 등록 실패");
        },
        onSuccess: () => {
            showAlert("제품 등록 완료", "완료");
            invalidateQueries([queries.product._def, queries.stock._def,]);
        },
    });
    const updateProductMutation = useMutation({
        mutationFn: async ({ id, body }) => isCommercialPage.value
            ? await patchCommercialProduct(id, body)
            : await patchResearchProduct(id, body),
        onError: (err) => {
            showAlert(getErrorMessage(err), "제품 수정 실패");
        },
        onSuccess: () => {
            showAlert("제품 수정 완료", "완료");
            invalidateQueries([queries.product._def, queries.stock._def,]);
        },
    });
    const deleteProductMutation = useMutation({
        mutationFn: async (id) => isCommercialPage.value
            ? await deleteCommercialProduct(id)
            : await deleteResearchProduct(id),
        onError: (err) => {
            showAlert(getErrorMessage(err), "제품 삭제 실패");
        },
        onSuccess: () => {
            showAlert("제품 삭제 완료", "완료");
            invalidateQueries([queries.product._def, queries.stock._def,]);
        },
    });
    return {
        readBOMQuery,
        createBOMMutation,
        updateBOMMutation,
        createProductMutation,
        updateProductMutation,
        deleteProductMutation,
        isCommercialPage,
        setProductId,
    };
};
